<template>
  <div
    class="filter-options"
    :class="`filter-options--${filter.type}`"
  >
    <component
      :is="optionalFilterableList"
      @filter="(query) => search = query"
    >
      <template v-if="topOptions.length && !search">
        <p><strong>{{ $t('Popular airlines') }}</strong></p>
        <ul class="filterable__list filter-options__list">
          <FilterOption
            v-for="option in topOptions"
            :key="option.key"
            :filter="filter"
            :option="option"
            @option-toggle="optionToggle"
          />
        </ul>
        <p><strong>{{ $t('Other airlines') }}</strong></p>
      </template>

      <ul class="filterable__list filter-options__list">
        <FilterOption
          v-for="option in limitedOptions"
          :key="option.key"
          :filter="filter"
          :option="option"
          @option-toggle="optionToggle"
        />
      </ul>
    </component>

    <div
      v-if="filter.options && filter.options.length > filter.numberUnfoldedOptions && filter.numberUnfoldedOptions > 0"
      class="filter-options__toggles"
    >
      <button
        type="button"
        class="filter-options__toggle"
        @click="showAll = !showAll"
      >
        <template v-if="showAll">
          <IconMin class="filter-options__icon icon icon--min" />
          <span>{{ $t('Show less options') }}</span>
        </template>
        <template v-else>
          <IconPlus class="filter-options__icon icon icon--min" />
          <span>{{ $t('Show all options') }}</span>
        </template>
      </button>
    </div>

    <button
      type="button"
      class="filter-options__apply"
      @click="$emit('filter-apply')"
    >
      {{ $t('Apply') }}
    </button>

    <button
      type="button"
      class="filter-options__reset"
      @click="$emit('filter-reset')"
    >
      {{ $t('Reset') }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import UiFilterableList from '~layers/app/components/Ui/FilterableList.vue'

const props = defineProps({
  filter: {
    type: Object,
    required: true,
  },
})

const optionalFilterableList = computed(() => {
  if (!props.filter.isShowSearchBox) {
    return 'div'
  }
  if (props.filter.limitOptionsShowSearchBox > 0 && props.filter.limitOptionsShowSearchBox > props.filter.options.length) {
    return 'div'
  }
  return UiFilterableList
})

const emit = defineEmits(['filter-apply', 'filter-reset', 'option-toggle'])

const optionToggle = (key: any) => {
  emit('option-toggle', key)
}

const showAll = ref(false)
const search = ref('')
const meta = inject('meta', ref())

const topAirlines = computed(() => {
  return meta.value?.airline_sequence || []
})

const topOptions = computed(() => {
  return topAirlines.value.map((airline: never) => {
    return props.filter?.options.find(option => option.key === airline)
  }).filter(Boolean)
})

const limitedOptions = computed(() => {
  const options = [
    ...(props.filter?.options || []),
  ].filter(option => search.value ? option.label.toLowerCase().includes(search.value.toLowerCase()) : !topOptions.value.includes(option.key))

  if (options.length && props.filter.numberUnfoldedOptions) {
    if (showAll.value) {
      return options
    }

    return options.slice(0, props.filter.numberUnfoldedOptions)
  }

  return options
})
</script>

<style>
@import url("~layers/app/components/Filter/Options.css");
</style>
